import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { INTRO_STEPS } from "./types";
import { PurpleEdgeLogo } from "./Topbar";
import "./IntroCard.scss";

// ─── Intro Card (Step 0) ─────────────────────────────────────────────────────

function IntroCard({ onStart, onGoBack }: { onStart: () => void; onGoBack: () => void }) {
  return (
    <div className="rah-intro-card">
      {/* Logo + title block */}
      <div className="rah-intro-card__hero">
        <div className="rah-intro-card__logo-circle">
          <PurpleEdgeLogo />
        </div>
        <h1 className="rah-intro-card__title">Let&apos;s find your next great hire</h1>
      </div>

      {/* Process steps */}
      <div className="rah-intro-card__steps">
        <div className="rah-intro-card__vline" />
        {INTRO_STEPS.map((step, index) => (
          <div key={step.title} className="rah-intro-card__step-item">
            <div className="rah-intro-card__step-circle">
              <span>{index + 1}</span>
            </div>
            <div className="rah-intro-card__step-content">
              <div className="rah-intro-card__step-title">{step.title}</div>
              <div className="rah-intro-card__step-desc">{step.description}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer: Go back + Get started */}
      <div className="rah-intro-card__footer">
        <button type="button" className="rah-intro-card__back-btn" onClick={onGoBack}>
          Go back
        </button>
        <button type="button" className="rah-intro-card__start-btn" onClick={onStart}>
          Get started
          <ChevronRightIcon sx={{ fontSize: 22 }} />
        </button>
      </div>
    </div>
  );
}

export default IntroCard;
